import React from "react";
import MultiPickerSelectedItems from "components/Picker/MultiPickerSelectedItems";
import VenueList from "./VenueList";

interface Props {
  selectedVenues: server.dto.VenueSmall[]
  onChange: (newVenues: server.dto.VenueSmall[]) => void
}

const VenueMultiPicker = (props: Props) => {
  return <MultiPickerSelectedItems
    selectedItems={props.selectedVenues}
    onRemove={props.onChange}
    getId={venue => venue.venueId}
    getLabel={venue => <div>
      {venue.name}
    </div>}
  >
    <VenueList
      onItemSelected={(item) => props.onChange([...props.selectedVenues, item])}
      excludeKeys={props.selectedVenues.map(cc => cc.venueId)}
    />
  </MultiPickerSelectedItems>;
};

export default VenueMultiPicker;